var styles = {"email":"Signup-module_email__Oad1t","customFields":"Signup-module_customFields__xQDpb","loginText":"Signup-module_loginText__1qdDB","textPreview":"Signup-module_textPreview__q1go3","container":"Signup-module_container__DGdfa"};

export { styles as default };
//# sourceMappingURL=Signup.module.scss.js.map
